import ApplicationConfig from "../config";

/**
 * Redirect
 */
const windowLocationRedirect = (link: string) => window.location.replace(`${ApplicationConfig.appBaseUrl}/${link}`)

export default windowLocationRedirect